import React from "react";

// Lightweight placeholder logo
const MeetUsLogo = ({ className }) => (
  <div className={className} style={{ display: "none" }} />
);

export default MeetUsLogo;
